import { FeatureAccess } from '@gearbelt/global';

import { useAWAStore } from '@/stores/awa.store';
import { useUserStore } from '@/stores/user.store';
import { useIsAWA } from '@/utils/awa';

export const useFeatureFlag = (flag: keyof FeatureAccess): boolean => {
  const { isAWA } = useIsAWA();
  const { org: webWorkspace } = useUserStore();
  const { workspace: awaWorkspace } = useAWAStore();

  const workspace = isAWA ? awaWorkspace : webWorkspace;
  return workspace?.featureAccess?.[flag] ?? false;
};
